/*
 * Unified Fleet Dashboard palette
 * Orange (#f26722) is reserved for hover highlights only (CSS).
 * Charts use a sequential cool palette — pick from index 0 onwards
 * based on how many segments/bars a chart has.
 */

// Sequential chart palette (no orange — pick N colors from the start)
export const CHART_COLORS = [
  "#10b981", // emerald
  "#3b82f6", // blue
  "#8b5cf6", // violet
  "#06b6d4", // cyan
  "#f59e0b", // amber
  "#ec4899", // pink
  "#6b7280", // gray (neutral / unknown)
  "#ef4444", // red (danger / faulted)
];

// Legacy alias
export const COLORS = CHART_COLORS;

// Semantic status colors (donuts, charger status)
export const STATUS_COLORS = {
  Available: "#10b981",
  Charging: "#f59e0b",
  Preparing: "#3b82f6",
  Faulted: "#ef4444",
  Unavailable: "#6b7280",
  "Suspended Ev": "#f59e0b",
  "Suspended Evse": "#f59e0b",
  Finishing: "#8b5cf6",
};

// Gauge colors — green primary with subtle green track
export const GAUGE_PRIMARY = "#10b981";
export const GAUGE_TRACK = "rgba(16,185,129,0.10)";

// Severity scale (good → bad → neutral)
export const SEVERITY_COLORS = ["#10b981", "#f59e0b", "#ef4444", "#6b7280"];

// ── Chart Picker: registry of all collapsible-section charts ──
export const CHART_PICKER_STORAGE_KEY = "fleet_dashboard_visible_charts";

export const CHART_REGISTRY = [
  // Operational Health
  { key: "chargerStatus", label: "Charging Status", section: "operationalHealth" },
  { key: "connectivity", label: "Connectivity", section: "operationalHealth" },
  { key: "fleetHealth", label: "Fleet Health", section: "operationalHealth" },
  { key: "offlineDuration", label: "Offline Duration", section: "operationalHealth" },
  // Site Locations
  { key: "geoMap", label: "Geo Map", section: "siteLocations" },
  // Firmware & Maintenance
  { key: "fwVersions", label: "Firmware Versions", section: "firmwareMaintenance" },
  { key: "fwFreshness", label: "Firmware Freshness", section: "firmwareMaintenance" },
  { key: "chargerModel", label: "Chargers by Model", section: "firmwareMaintenance" },
  { key: "skuDistribution", label: "SKU Distribution", section: "firmwareMaintenance" },
  // Fleet Configuration
  { key: "phaseConfig", label: "Phase Configuration", section: "fleetConfig" },
  { key: "dlbAdoption", label: "DLB Adoption", section: "fleetConfig" },
  { key: "partnerIntegration", label: "Partner Integration", section: "fleetConfig" },
  { key: "offGridStatus", label: "Off-Grid Status", section: "fleetConfig" },
  // Deployment & Config
  { key: "chargingMode", label: "Charging Mode", section: "deploymentConfig" },
  { key: "offPeakEligibility", label: "Off-Peak Eligibility", section: "deploymentConfig" },
  { key: "vendorDistribution", label: "Vendor Distribution", section: "deploymentConfig" },
  { key: "maxCurrent", label: "Max Current", section: "deploymentConfig" },
];

export const SECTION_LABELS = {
  operationalHealth: "Operational Health",
  siteLocations: "Site Locations",
  firmwareMaintenance: "Firmware & Maintenance",
  fleetConfig: "Fleet Configuration",
  deploymentConfig: "Deployment & Config",
};

// API endpoints
export const SITE_UTILIZATION_URL = "/service/iqevse-csms/sessions/v1/site";
export const SYSTEM_INFO_URL = "/service/systems";

// Date formats
export const DATE_FORMAT_DD_MM_YYYY = "DD-MM-YYYY";
export const DATE_FORMAT_DISPLAY = "MMM D";
